import type { AdminV2Job, AdminV2JobStatus } from "@/types/adminV2";

export const buildJobsMonitorQueryArgs = (args: {
  statusFilter: AdminV2JobStatus | "all";
  jobTypeFilter: string;
  limit?: number;
}) => {
  const jobType = args.jobTypeFilter.trim();

  return {
    ...(args.statusFilter === "all" ? {} : { status: args.statusFilter }),
    ...(jobType.length > 0 ? { jobType } : {}),
    limit: args.limit ?? 200,
  };
};

export const getJobStatusChipColor = (
  status: AdminV2JobStatus,
): "default" | "warning" | "error" | "success" | "info" => {
  if (status === "succeeded") {
    return "success";
  }
  if (status === "failed") {
    return "error";
  }
  if (status === "running") {
    return "info";
  }
  if (status === "cancelled") {
    return "default";
  }
  return "warning";
};

export type JobStatusCounts = Record<AdminV2JobStatus, number>;

export const countJobStatuses = (jobs: AdminV2Job[]): JobStatusCounts => {
  const counts: JobStatusCounts = {
    queued: 0,
    running: 0,
    succeeded: 0,
    failed: 0,
    cancelled: 0,
  };

  jobs.forEach((job) => {
    counts[job.status] += 1;
  });

  return counts;
};

export const computeFailureRatePercent = (
  failedCount: number,
  total: number,
): number => {
  if (total <= 0) {
    return 0;
  }
  return Math.round((failedCount / total) * 100);
};
